import { executeQuery } from "utils/services/apiServices";
import { FETCH_COMMERCAIL_TOTAL_USER, FETCH_MEMBERSHIP_COUNT } from "../graphql/query";
import { actionTypes, CommercialTotalUserDataInput, MembershipCountProps } from "./actionType";
import { DcddTotalUserDataInput, DcddTotalUserProps } from "modules/report/dcdd_report/state/actionType";

export const fetchCommercialTotalUserRequest = () => ({
    type: actionTypes.FETCH_COMMERCIAL_TOTAL_USER_REQUEST
});

export const fetchCommercialTotalUserSuccess = (payload: DcddTotalUserProps) => ({
    type: actionTypes.FETCH_COMMERCIAL_TOTAL_USER_SUCCESS,
    payload
});

export const fetchCommercialTotalUserFail = (payload: string) => ({
    type: actionTypes.FETCH_COMMERCIAL_TOTAL_USER_FAIL,
    payload
});

export const fetchCommercialTotalUser = (from_date:string | null = null, to_date:string| null = null) => {
    return async (dispatch: any) => {
        try {
            await dispatch(fetchCommercialTotalUserRequest());
            const response = await executeQuery(FETCH_COMMERCAIL_TOTAL_USER,{from_date, to_date});
            const jsonData = response.data?.getCommercialUserTotals;
            if (jsonData?.error === null) {
                dispatch(fetchCommercialTotalUserSuccess(jsonData?.data));
            } else {
                dispatch(fetchCommercialTotalUserFail(jsonData?.error.message));
            }
        } catch (error: any) {
            dispatch(fetchCommercialTotalUserFail('Failed to fetch VideoCategories'));
        }
    };
};

export const fetchCommercialTotalUserByFilterRequest = () => ({
    type: actionTypes.FETCH_COMMERCIAL_TOTAL_USER_BY_FILTER_REQUEST
});

export const fetchCommercialTotalUserByFilterSuccess = (payload: DcddTotalUserProps) => ({
    type: actionTypes.FETCH_COMMERCIAL_TOTAL_USER_BY_FILTER_SUCCESS,
    payload
});

export const fetchCommercialTotalUserByFilterFail = (payload: string) => ({
    type: actionTypes.FETCH_COMMERCIAL_TOTAL_USER_BY_FILTER_FAIL,
    payload
});

export const fetchCommercialTotalUserByFilter = (input: CommercialTotalUserDataInput) => {
    return async (dispatch: any) => {
        try {
            await dispatch(fetchCommercialTotalUserByFilterRequest());
            const response = await executeQuery(FETCH_COMMERCAIL_TOTAL_USER, input);
            const jsonData = response.data?.getCommercialUserTotals;
            if (jsonData?.error === null) {
                dispatch(fetchCommercialTotalUserByFilterSuccess(jsonData?.data));
            } else {
                dispatch(fetchCommercialTotalUserByFilterFail(jsonData?.error.message));
            }
        } catch (error: any) {
            dispatch(fetchCommercialTotalUserByFilterFail('Failed to fetch VideoCategories'));
        }
    };
};
export const fetchMembershipCountRequest = () => ({
    type: actionTypes.FETCH_FETCH_MEMBERSHIP_COUNT_REQUEST
});

export const fetchMembershipCountSuccess = (payload: MembershipCountProps) => ({
    type: actionTypes.FETCH_FETCH_MEMBERSHIP_COUNT_SUCCESS,
    payload
});

export const fetchMembershipCountFail = (payload: string) => ({
    type: actionTypes.FETCH_FETCH_MEMBERSHIP_COUNT_FAIL,
    payload
});

export const fetchMembershipCount = () => {
    return async (dispatch: any) => {
        try {
            await dispatch(fetchMembershipCountRequest());
            const response = await executeQuery(FETCH_MEMBERSHIP_COUNT,);
            const jsonData = response.data?.fetchMembershipCount;
            if (jsonData?.error === null) {
                dispatch(fetchMembershipCountSuccess(jsonData?.data));
            } else {
                dispatch(fetchMembershipCountFail(jsonData?.error.message));
            }
        } catch (error: any) {
            dispatch(fetchMembershipCountFail('Failed to fetch VideoCategories'));
        }
    };
};

//reset data

export const ResetCommercialFilterData = () => ({
    type: actionTypes.RESET_COMMERCIAL_FILTER_DATA
});

export const resetDcddFiterData = () => {
    return async (dispatch:any) => {
        dispatch(ResetCommercialFilterData())
    }
}
